import { ConfigConstants, PACE_PLATFORM, PaceEnvironment } from '@evorait/pace-core';

export const environment: PaceEnvironment = {
    production: true,
    operateInMockMode: false,
    appId: 'com.siemens.medical.solutions.usa.pacepwa',
    serviceHost: 'pace-non-prod-backend-xgid.azurewebsites.net',
    servicePath: 'api/proxy',
    serviceProtocol: ConfigConstants.https,
    reportIssueSupportEmail: 'healthcaretest@service-now.com',
    reportIssueUrl: 'https://pace-non-prod-backend-xgid.azurewebsites.net',
    bundleIdentifierName: 'PACE',
    platform: PACE_PLATFORM.BROWSER,
    subscribeNotificationsUrl: 'https://pace-non-prod-backend-xgid.azurewebsites.net',
    subscriptionServerPublicKey:
        'BGXPTVy72unf7at8QszwD9YXjraFD5JEIS5lpi4q8T46hSTCcZy2fOrfrKBn2kPt4QvlQ28fk2LEAzbyTo3TAPQ',
    complaintsLinkUrl: 'https://pace-non-prod-backend-xgid.azurewebsites.net/api/ComplaintsLink',
    auth0: {
        // using Prod Auth0 tenant for now as there is setup missing for non-prod
        domain: 'shs.login.siemens-healthineers.com',
        clientId: 'kWjWnJw8R6u97GUjl9zoWdt4SZhfF7li',
        authorizationParams: {
            audience: 'api://kWjWnJw8R6u97GUjl9zoWdt4SZhfF7li/user_impersonation',
            response_type: 'code',
            redirect_uri: window.location.origin,
        },
        errorPath: '/error',
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
    },
};
